// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__biouT","content":"styles_content__3BUOY","checkbox":"styles_checkbox__3Bv-G","checkboxLabel":"styles_checkboxLabel__BJqTS"};